import { render, staticRenderFns } from "./addView.vue?vue&type=template&id=0944096f&scoped=true"
import script from "./addView.vue?vue&type=script&lang=js"
export * from "./addView.vue?vue&type=script&lang=js"
import style0 from "./addView.vue?vue&type=style&index=0&id=0944096f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0944096f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0944096f')) {
      api.createRecord('0944096f', component.options)
    } else {
      api.reload('0944096f', component.options)
    }
    module.hot.accept("./addView.vue?vue&type=template&id=0944096f&scoped=true", function () {
      api.rerender('0944096f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/baseInfo/koofee/scene/addView.vue"
export default component.exports